// @generated by TypeGen from LogbookApi/Subscriptions - DO NOT EDIT

import type { ILocalShip } from "../LogbookApp/AppState"
import type { ILogbookAppStatusResult } from "../LogbookApp/AppStatus"
import type { IAccount } from "../LogbookModel/Account"
import type { IAccountUser } from "../LogbookModel/AccountUser"
import type { ICruise } from "../LogbookModel/Cruise"
import type { IDataRecord } from "../LogbookModel/DataRecord"
import type { IDay } from "../LogbookModel/Day"
import type { ILog } from "../LogbookModel/Log"
import type { INote } from "../LogbookModel/Note"
import type { INoteAttachment } from "../LogbookModel/NoteAttachment"
import type { ISettings } from "../LogbookModel/Settings"
import type { IShip } from "../LogbookModel/Ship"
import type { IShipUser } from "../LogbookModel/ShipUser"
import type { IStatus } from "../LogbookModel/Status"
import type { IStoredCalculation } from "../LogbookModel/StoredCalculation"
import type { ITrack } from "../LogbookModel/Track"
import type { ITrip } from "../LogbookModel/Trip"
import type { IUser } from "../LogbookModel/User"

export interface SubscriptionMap {
  Account: IAccount;
  AccountUser: IAccountUser;
  AppStatus: ILogbookAppStatusResult;
  Cruise: ICruise;
  DataRecord: IDataRecord;
  Day: IDay;
  "Day/Navigation": IDay;
  LocalShip: ILocalShip;
  Log: ILog;
  "Log/Current": ILog;
  "Log/Provisional": ILog;
  Note: INote;
  NoteAttachment: INoteAttachment;
  Settings: ISettings;
  Ship: IShip;
  "Ship/Close": IShip;
  ShipUser: IShipUser;
  Status: IStatus;
  StoredCalculation: IStoredCalculation;
  "StoredCalculation/Cruise": IStoredCalculation;
  "StoredCalculation/Day": IStoredCalculation;
  "StoredCalculation/Log": IStoredCalculation;
  "StoredCalculation/Ship": IStoredCalculation;
  "StoredCalculation/Status": IStoredCalculation;
  "StoredCalculation/Test": IStoredCalculation;
  "StoredCalculation/Trip": IStoredCalculation;
  Track: ITrack;
  Trip: ITrip;
  User: IUser;
}

export type SubscriptionType = keyof SubscriptionMap;

export interface SubscriptionToken<_T> {
  readonly type: SubscriptionType;
}

export const Subscription = {
  Account: { type: "Account" } as SubscriptionToken<IAccount>,
  AccountUser: { type: "AccountUser" } as SubscriptionToken<IAccountUser>,
  AppStatus: { type: "AppStatus" } as SubscriptionToken<ILogbookAppStatusResult>,
  Cruise: { type: "Cruise" } as SubscriptionToken<ICruise>,
  DataRecord: { type: "DataRecord" } as SubscriptionToken<IDataRecord>,
  Day: { type: "Day" } as SubscriptionToken<IDay>,
  LocalShip: { type: "LocalShip" } as SubscriptionToken<ILocalShip>,
  Log: { type: "Log" } as SubscriptionToken<ILog>,
  Note: { type: "Note" } as SubscriptionToken<INote>,
  NoteAttachment: { type: "NoteAttachment" } as SubscriptionToken<INoteAttachment>,
  Settings: { type: "Settings" } as SubscriptionToken<ISettings>,
  Ship: { type: "Ship" } as SubscriptionToken<IShip>,
  ShipUser: { type: "ShipUser" } as SubscriptionToken<IShipUser>,
  Status: { type: "Status" } as SubscriptionToken<IStatus>,
  StoredCalculation: { type: "StoredCalculation" } as SubscriptionToken<IStoredCalculation>,
  Track: { type: "Track" } as SubscriptionToken<ITrack>,
  Trip: { type: "Trip" } as SubscriptionToken<ITrip>,
  User: { type: "User" } as SubscriptionToken<IUser>,
  currentLog: { type: "Log/Current" } as SubscriptionToken<ILog>,
  dayNavigation: { type: "Day/Navigation" } as SubscriptionToken<IDay>,
  provisionalLog: { type: "Log/Provisional" } as SubscriptionToken<ILog>,
  shipClose: { type: "Ship/Close" } as SubscriptionToken<IShip>,
  storedCalculationCruise: { type: "StoredCalculation/Cruise" } as SubscriptionToken<IStoredCalculation>,
  storedCalculationDay: { type: "StoredCalculation/Day" } as SubscriptionToken<IStoredCalculation>,
  storedCalculationLog: { type: "StoredCalculation/Log" } as SubscriptionToken<IStoredCalculation>,
  storedCalculationShip: { type: "StoredCalculation/Ship" } as SubscriptionToken<IStoredCalculation>,
  storedCalculationStatus: { type: "StoredCalculation/Status" } as SubscriptionToken<IStoredCalculation>,
  storedCalculationTest: { type: "StoredCalculation/Test" } as SubscriptionToken<IStoredCalculation>,
  storedCalculationTrip: { type: "StoredCalculation/Trip" } as SubscriptionToken<IStoredCalculation>,
} as const;

export function accountChannel(id: string): string {
  return `account:${id}`;
}

export function shipChannel(id: string): string {
  return `ship:${id}`;
}

export const subscriptionStream = {
  path: "/api/stream",
  token: "token",
  since: "since",
} as const;
